


























































































































































import { Component, Watch } from 'vue-property-decorator';

import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import WidgetAlerta from '@/pantallas/Camaras/Alertas/WidgetAlerta.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { GridOptions, GridApi, GridReadyEvent } from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import showImage from '@/pantallas/Camaras/Alertas/showImage.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';

import { PermisoAccion } from '@/views/base/VariablesPermisos';

@Component({
  components: {
    MantenedorGrid,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    WidgetAlerta,
    showImage,
    FormFieldsContainer,
    DatePicker,
  },
})
export default class InformePreparacionBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.InformePreparacion;
  loadingService = new LoadingService();
  filtrobusquedagrilla: string = '';
  filtro: any;
  reporteSeleccionado: Number = null;
  serieNumeroSeleccionado: string = null;
  tipoEquipoSeleccionado: string = null;
  serieactivanroSeleccionado: string = null;
  showReporteGenerado: boolean = false;
  tipoeqid: any = '';
  pagina: number = 1;
  length_FLOTA: number = 2;
  length_RUT: number = 2;
  columnApi: any = null;
  gridEvent: any = null;
  serverSide: any;
  gridApi: GridApi = null;
  texto_reporte: string = '';
  estadosList: any[] = [];
  equiposlist: any[] = [];
  requermientoslist: any[] = [];
  flotalist: any[] = [];
  mandanteList: any[] = [];
  bloquelist: any[] = [];
  crm_rutlist: any = [];
  ordesList: any = [];
  estadolist: any = [];
  showModalMostrar: boolean = false;
  usuarioID: any = '';
  hashpaginacion: string = '';
  rowcount: number = 0;
  total_registros: number = 0;
  cant_regs_pag: number = 25;
  today: string = moment().format('YYYY-MM-DD');

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { '': '' },
      'conectaReportePreparacion/get_grilla_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.estadosList = data.data.ESTADO;
          self.mandanteList = data.data.CLIENTE;
          self.equiposlist = data.data.EQUIPOS;
          console.log(data.data);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        console.log(error);
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Fecha',
        field: 'Fecha',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 100,
      },
      {
        headerName: 'Requerimiento',
        field: 'Requerimiento',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'ADP',
        field: 'ADP',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Cliente',
        field: 'Cliente',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Flota',
        field: 'Flota',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Mandante',
        field: 'Mandante',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Orden de Compra',
        field: 'Orden de Compra',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Estado de Preparación',
        field: 'Estado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Tipo de Equipo',
        field: 'Tipo de Equipo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Serie Número',
        field: 'Serie Número',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 100,
      },

      {
        headerName: 'EPC',
        field: 'EPC',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
      },
      {
        headerName: 'Modalidad',
        field: 'Modalidad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 100,
      },
      {
        headerName: 'Cantidad No Seriado',
        field: 'Cantidad No seriados',
        cellStyle: { textAlign: 'left' },
        width: 140,
      },
      {
        headerName: 'Descripción No Seriados',
        field: 'Descripción No Seriados',
        cellStyle: { textAlign: 'left' },
        width: 140,
      },
    ],

    pagination: true,
    paginationPageSize: 25,
    onGridReady: this.handleGridReady,
  };
  async handleGridReady(event: GridReadyEvent) {
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    this.ordesList = await this.getReportes();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.getEquipos();
    // this.clearFilters();
  }

  async getReportes() {
    let self = this;
    this.loadingService.showLoading();
    const filterDate = {
      start_date: this.formFields.fechaInicio.value,
      end_date: this.formFields.fechaFin.value,
    };
    return fetchReportesSerie({ ...filterDate }, 'conectaReportePreparacion')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  @Watch('formFields.fechaInicio.value')
  handleStartDate(): void {
    if (this.formFields.fechaInicio.value > this.formFields.fechaFin.value) {
      this.formFields.fechaFin.value = this.formFields.fechaInicio.value;
    }
  }

  @Watch('formFields.fechaFin.value')
  handleEndDate(): void {
    if (this.formFields.fechaFin.value < this.formFields.fechaInicio.value) {
      this.formFields.fechaInicio.value = this.formFields.fechaFin.value;
    }
  }

  formFields: FormFieldDefMap = {
    estado: {
      label: 'Estado',
      id: '',
      value: '',
    },
    requerimiento: {
      label: 'Requerimiento',
      id: 'requerimiento',
      value: '',
    },
    razonsocial: {
      label: 'Cliente',
      id: '',
      value: '',
    },
    mandante: {
      label: 'Mandante',
      id: '',
      value: '',
    },
    oc: {
      label: 'Orden de Compra',
      id: '',
      value: '',
    },
    soc: {
      label: 'Sin Orden de Compra',
      id: '',
      value: '',
    },
    tipoeq: {
      label: 'Tipo de Equipo',
      id: '',
      value: '',
    },
    serieEq: {
      label: 'Serie Número',
      id: '',
      value: '',
    },
    epc: {
      label: 'EPC',
      id: '',
      value: '',
    },
    fechaInicio: {
      label: 'Fecha Inicio',
      id: 'fechaInicio',
      value: moment().subtract(1, 'months'),
    },
    fechaFin: {
      label: 'Fecha Fin',
      id: 'fechaFin',
      value: moment(),
    },
  };

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }
  async handleBuscarClick() {
    let body: any = this.filtros2body();
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        requerimiento: body.requerimiento,
        estado: body.estado,
        cliente: body.cliente,
        mandante: body.mandante,
        tipoeq: body.tipoeq,
        epc: body.epc,
        oc: body.oc,
        serieEq: body.serieEq,
        dateStart: body.dateStart,
        dateEnd: body.dateEnd,
        soc: body.soc,
      },
      'conectaReportePreparacion/get_filtered_rs'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.gridApi.setRowData(data.data.data.LISTA);
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.gridApi.setRowData((this.ordesList = []));
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async clearFilters() {
    Object.entries(this.formFields).forEach(
      ([field, data]) => (data.value = '')
    );
    this.formFields.fechaInicio.value = moment().subtract(1, 'month');
    this.formFields.fechaFin.value = moment();
    this.handleBuscarClick();
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionExportar,
  ];

  filtros2body() {
    let body: any = {};
    body.requerimiento = this.formFields.requerimiento.value
      ? this.formFields.requerimiento.value
      : '';
    body.estado = this.formFields.estado.value
      ? this.formFields.estado.value
      : '';
    body.cliente = this.formFields.razonsocial.value
      ? this.formFields.razonsocial.value
      : '';
    body.mandante = this.formFields.mandante.value
      ? this.formFields.mandante.value
      : '';
    body.tipoeq = this.formFields.tipoeq.value
      ? this.formFields.tipoeq.value
      : '';
    body.epc = this.formFields.epc.value ? this.formFields.epc.value : '';
    body.oc = this.formFields.oc.value ? this.formFields.oc.value : '';

    body.serieEq = this.formFields.serieEq.value
      ? this.formFields.serieEq.value
      : '';
    body.dateStart = this.formFields.fechaInicio.value
      ? this.formFields.fechaInicio.value
      : '';
    body.dateEnd = this.formFields.fechaFin.value
      ? this.formFields.fechaFin.value
      : '';
    body.soc = this.formFields.soc.value ? this.formFields.soc.value : '';
    body.serieEq = this.formFields.serieEq.value
      ? this.formFields.serieEq.value
      : '';
    console.log(body);
    return body;
  }
  async btn_exportar() {
    let body: any = this.filtros2body();
    (body.extension = 'csv'),
      this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchReportesSerie(
      {
        body: body,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        user_id: JSON.parse(localStorage.getItem('user')).id,
        tipo_alerta: 'REPORTE DE PREPARACIÓN DE EQUIPO',
      },
      'conectaReportePreparacion/exportar'
    )
      .then((data: any) => {
        this.showReporteGenerado = true;
        this.loadingService.hideLoading('btn_exportar');
        this.texto_reporte = data.data.MENSAJE_RESPUESTA;
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }
}
